import React, { useEffect, useRef } from "react";
import help_icon from "../../images/sidebar_icon/help_icon.svg";
import InvestmentHeaderBox1 from "../InvestmentHeaderBox1";
import "../../styles/profile.css";
import { Formik, Form, Field, ErrorMessage, useFormik } from "formik";
import * as Yup from "yup";
import SelectDropDown from "../SelectDropDown";
import DatePickerInput from "../DatePickerInput";
import { useDispatch, useSelector } from "react-redux";
import { InvestorAddFormData } from "../../actions/adminAction";
import { pincode } from "../../actions/usersActions";
import { convertDateToDDMMMYYYY } from "../../utils/DateFormate";
import moment from "moment";
// Functional component for the Home page
const FaqAdd = (props) => {
  const dispatch = useDispatch();
  const { formik } = props;
  // Fetch existing data if editing
  useEffect(() => {
    dispatch(InvestorAddFormData());
  }, [dispatch]);
  const userOnboardGetData =
    useSelector((state) => state.admin.adminAddInvestorData) || {};
  // console.log(userOnboardGetData?.data?.occupation, "userGetProfile1");

  const genderOptions = [
    { value: "M", label: "Male" },
    { value: "F", label: "Female" },
    { value: "O", label: "Other" },
  ];

  const maritalOptions = [
    { value: "MARRIED", label: "Married" },
    { value: "UNMARRIED", label: "Unmarried" },
    { value: "OTHER", label: "Other" },
  ];

  const callStateAndDistrict = async (pin) => {
    try {
      if (pin?.split("")?.length == 6) {
        const payload = {
          pincode: pin,
        };
        dispatch(pincode(payload))
          .then((res) => {
            {console.log("res", res, userOnboardGetData)}
            formik?.setFieldValue(
              "city",
              res?.data?.data?.city ? res?.data?.data?.city : ""
            );
            formik?.setFieldValue(
              "state",
              res?.data?.data?.state_code ? res?.data?.data?.state_code : ""
            );
          })
          .catch((error) => {
            console.log("Error:", error);
          });
      }
    } catch (error) {
      console.error("Error fetching location data:", error);
    }
  };
  return (
    <div>
      <div className="row form_body justify-content-center">
        <div className="col-xl-8 col-lg-10 col-md-11 ">
          <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
            <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
              <label className="form-label">
                First Name <span className="red-color">*</span>
              </label>
            </div>
            <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
              <input
                type="text"
                className="form-control"
                id="primary_holder_first_name"
                placeholder="Enter Full Name"
                {...formik.getFieldProps("primary_holder_first_name")}
              />
              {/* {formik.errors.name  (
                          <div className="text-danger">
                            {formik.errors.name}
                          </div>
                        ) : null} */}
              {formik.touched.primary_holder_first_name && formik.errors.primary_holder_first_name && (
                <div className="text-danger">
                  {formik.errors.primary_holder_first_name}
                </div>
              )}
            </div>
          </div>
          <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
            <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
              <label className="form-label">
                Father/Husband Name
              </label>
            </div>
            <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
              <input
                type="text"
                className="form-control"
                id="primary_holder_middle_name"
                placeholder="Enter Father/Husband Name"
                {...formik.getFieldProps("primary_holder_middle_name")}
              />
              {/* {formik.touched.primary_holder_middle_name && formik.errors.primary_holder_middle_name ? (
                <div className="text-danger">
                  {formik.errors.primary_holder_middle_name}
                </div>
              ) : null} */}
            </div>
          </div>

          <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
            <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
              <label className="form-label">
                Last Name <span className="red-color">*</span>
              </label>
            </div>
            <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
              <input
                type="text"
                className="form-control"
                id="primary_holder_last_name"
                placeholder="Enter Last Name"
                {...formik.getFieldProps("primary_holder_last_name")}
              />
              {formik.touched.primary_holder_last_name && formik.errors.primary_holder_last_name ? (
                <div className="text-danger">
                  {formik.errors.primary_holder_last_name}
                </div>
              ) : null}
            </div>
          </div>

          <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
            <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
              <label className="form-label">
                Date of Birth <span className="red-color">*</span>
              </label>
            </div>
            <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
              {/* <DatePickerInput
                selectedDate={formik.values.primary_holder_dob_incorporation}
                maxDate={new Date().toISOString().split("T")[0]}
                 onChange={(date) =>
                                            formik.setFieldValue(
                                              "primary_holder_dob_incorporation",
                                              moment(date).format("YYYY-MM-DD") // Save in DB-friendly format
                                            )
                                          }
                // disable="true"
              /> */}

              <DatePickerInput
                                        id={`primary_holder_dob_incorporation`}
                               selectedDate={formik.values.primary_holder_dob_incorporation}
                                maxDate={new Date().toISOString().split("T")[0]}
                                onChange={(date) => formik.setFieldValue("primary_holder_dob_incorporation", date)}
                                name={"primary_holder_dob_incorporation"}
                                      />

              {formik.touched.primary_holder_dob_incorporation && formik.errors.primary_holder_dob_incorporation && (
                <div className="text-danger">
                  {formik.errors.primary_holder_dob_incorporation}
                </div>
              )}{" "}
            </div>
          </div>

          <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
            <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
              <label className="form-label">
                Email <span className="red-color">*</span>
              </label>
            </div>
            <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
              <input
                type="email"
                className="form-control"
                id="email"
                placeholder="anandr@gmail.com"
                {...formik.getFieldProps("email")}
                  onChange={(e) => formik.setFieldValue("email", e.target.value.toLowerCase())}
              />
              {formik.touched.email && formik.errors.email && (
                <div className="text-danger">{formik.errors.email}</div>
              )}
            </div>
          </div>
          <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
            <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
              <label className="form-label">
                Mobile Number <span className="red-color">*</span>
              </label>
            </div>
            <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
              <input
                type="text"
                className="form-control"
                id="indian_mobile_no"
                placeholder="9876543210"
                {...formik.getFieldProps("indian_mobile_no")}
              />
              {formik.touched.indian_mobile_no && formik.errors.indian_mobile_no && (
                <div className="text-danger">
                  {formik.errors.indian_mobile_no}
                </div>
              )}
            </div>
          </div>

          <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
            <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
              <label className="form-label">
                Gender <span className="red-color">*</span>
              </label>
            </div>
            <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
              <div className="d-flex align-items-center gap-2 flex-wrap">
                {genderOptions.map(({ value, label }) => (
                  <div className="form-check form-check-inline" key={value}>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="gender"
                      id={value}
                      value={value}
                      onChange={formik.handleChange}
                      checked={formik.values.gender === value}
                    />
                    <label className="form-check-label ms-2" htmlFor={value}>
                      {label}
                    </label>
                  </div>
                ))}{" "}
              </div>
              {formik.touched.gender && formik.errors.gender ? (
                <div className="text-danger">{formik.errors.gender}</div>
              ) : null}
            </div>
          </div>

          {/* <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
            <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
              <label className="form-label">
                Marital Status <span className="red-color">*</span>
              </label>
            </div>
            <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
              <div className="d-flex align-items-center gap-2 flex-wrap">
                {maritalOptions.map(({ value, label }) => (
                  <div className="form-check form-check-inline" key={value}>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="marital_status"
                      id={value}
                      value={value}
                      onChange={formik.handleChange}
                      checked={formik.values.marital_status === value}
                    />
                    <label className="form-check-label ms-2" htmlFor={value}>
                      {label}
                    </label>
                  </div>
                ))}
              </div>

              {formik.errors.marital_status ? (
                <div className="text-danger">
                  {formik.errors.marital_status}
                </div>
              ) : null}
            </div>
          </div> */}
          <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
            <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
              <label className="form-label">
                Occupation <span className="red-color">*</span>
              </label>
            </div>
            <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
              <SelectDropDown
                name="occupation_code"
                id=""
                placeholder="Select Occupation"
                value={formik?.values?.occupation_code}
                changeFunction={(value) =>
                  formik?.setFieldValue("occupation_code", value)
                }
                options={userOnboardGetData?.data?.occupation?.map((occ) => ({
                  value: occ.occupation_code,
                  label: occ.occupation_name,
                }))}
              />
              {formik.touched.occupation_code && formik.errors.occupation_code ? (
                <div className="text-danger">
                  {formik.errors.occupation_code}
                </div>
              ) : null}{" "}
            </div>
          </div>

          <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
            <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
              <label className="form-label">
                PAN <span className="red-color">*</span>
              </label>
            </div>
            <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
              <input
                type="text"
                className="form-control"
                id="primary_holder_pan"
                placeholder="Enter PAN"
                {...formik.getFieldProps("primary_holder_pan")}
                value={formik.values.primary_holder_pan?.toUpperCase() || ""}
                onChange={(e) =>
                {  formik.setFieldValue(
                    "primary_holder_pan",
                    e.target.value.toUpperCase()
                  )
                  formik.setFieldValue(
                    "tax_payer_identityno1",
                    e.target.value.toUpperCase()
                  )}
                }
              />
              {formik.touched.primary_holder_pan && formik.errors.primary_holder_pan ? (
                <div className="text-danger">
                  {formik.errors.primary_holder_pan}
                </div>
              ) : null}
            </div>
          </div>

          {/* <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
            <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
              <label className="form-label">
                Aadhar Number <span className="red-color">*</span>
              </label>
            </div>
            <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
              <input
                type="text"
                className="form-control"
                id="adhaar_card"
                placeholder="Enter Aadhar Number"
                {...formik.getFieldProps("adhaar_card")}
              />
              {formik.errors.adhaar_card ? (
                <div className="text-danger">{formik.errors.adhaar_card}</div>
              ) : null}
            </div>
          </div> */}

          <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
            <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
              <label className="form-label">
                Address <span className="red-color">*</span>
              </label>
            </div>
            <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
              <input
                type="text"
                className="form-control"
                id="address_1"
                placeholder="Enter Address"
                {...formik.getFieldProps("address_1")}
              />
              {formik.touched.address_1 && formik.errors.address_1 ? (
                <div className="text-danger">{formik.errors.address_1}</div>
              ) : null}
            </div>
          </div>

          <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
            <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
              <label className="form-label">
                Pincode <span className="red-color">*</span>
              </label>
            </div>
            <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
              <input
                type="text"
                className="form-control"
                id="pincode"
                name="pincode"
                placeholder="Enter Pincode"
                onChange={(e) => {
                  formik.handleChange(e); // Handle Formik's change
                  callStateAndDistrict(e.target.value); // Call your custom function
                }}
                value={formik.values.pincode}
              />
              {formik.touched.pincode && formik.errors.pincode ? (
                <div className="text-danger">{formik.errors.pincode}</div>
              ) : null}
            </div>
          </div>

          <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
            <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
              <label className="form-label">
                City <span className="red-color">*</span>
              </label>
            </div>
            <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
              <input
                type="text"
                className="form-control"
                id="city"
                placeholder="Enter City"
                {...formik.getFieldProps("city")}
              />
              {formik.touched.city && formik.errors.city ? (
                <div className="text-danger">{formik.errors.city}</div>
              ) : null}
            </div>
          </div>

          <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
            <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
              <label className="form-label">
                State <span className="red-color">*</span>
              </label>
            </div>
            <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
              <SelectDropDown
                name="state"
                id=""
                value={formik?.values?.state}
                changeFunction={(value) =>
                  formik?.setFieldValue("state", value)
                }
                options={userOnboardGetData?.data?.states.map((state) => ({
                  value: state.state_code,
                  label: state.state_name,
                }))}
              />
              {formik.touched.state && formik.errors.state ? (
                <div className="text-danger">{formik.errors.state}</div>
              ) : null}{" "}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaqAdd;
